import React from "react";
import { nFormatter } from "utils/currencyFormat";

const khachHangConst = {
  TinhTrangKhachHang: {
    BinhThuong: 0,
    NoXau: 2,
    RuiRo: 3,
  },
  TinhTrangKhachHangText: {
    0: "Bình thường",
    50: "Nợ xấu",
    20: "Rủi ro",
  },

  LoaiDoiTac: {
    0: "Chủ nợ",
    1: "Khách hàng",
  },
};
export const KhachHangCombo = {
  TinhTrangKhachHangCombo: [
    { value: "-1", label: "Tất cả" },
    { value: "0", label: "Bình thường" },
    { value: "50", label: "Nợ xấu" },
    { value: "20", label: "Nợ rủi ro" },
  ],
  LoaiDoiTacCombo: [
    { value: "-1", label: "Tất cả" },
    { value: "0", label: "Chủ nợ" },
    { value: "1", label: "Khách hàng" },
  ],

  TrangThaiCombo: [
    { value: "-1", label: "Tất cả" },
    { value: "0", label: "Đang vay" },
    { value: "1", label: "Kết thúc" },
    { value: "2", label: "Chưa có hợp đồng" },
  ],
};

export default khachHangConst;
